import { render, staticRenderFns } from "./Castle.vue?vue&type=template&id=6e7f9d33&scoped=true"
import script from "./Castle.vue?vue&type=script&lang=js"
export * from "./Castle.vue?vue&type=script&lang=js"
import style0 from "./Castle.vue?vue&type=style&index=0&id=6e7f9d33&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e7f9d33",
  null
  
)

export default component.exports